import { connect } from 'react-redux';
import Accounts from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(Accounts);
